import styles from './styles.module.css';
import Image from 'next/image';

import logo_chippu_place from '@/assets/logo_chippu_place.svg';
import { IconeBusca } from '@/components/atoms/Icones/IconeBusca';
import { IconeMenu } from '@/components/atoms/Icones/IconeMenu';
import { theme } from '@/styles/theme';
import Header, { HeaderProps } from '@/components/atoms/Header';
import { IconeSacola } from '@/components/atoms/Icones/IconeSacola';

export default function CabecalhoHomeFallback(props: HeaderProps) {
  return (
    <Header {...props} $style={{ padding: theme.spacing[4] }}>
      <div className={styles.toolbar}>
        <div style={{ padding: theme.spacing[1] }}>
          <IconeMenu
            size={theme.typography.font.size[6]}
            color={theme.colors.neutral.neutral['12']}
          />
        </div>
        <Image
          src={logo_chippu_place}
          alt="Chippu Place logo"
          height={theme.typography.font.size[7]}
          priority
        />
        <div style={{ padding: theme.spacing[1] }}>
          <IconeSacola
            size={theme.typography.font.size[6]}
            color={theme.colors.neutral.neutral['12']}
          />
        </div>
      </div>
      <div
        className={styles.campoBuscaContainer}
        style={{
          marginTop: -theme.spacing[1],
          padding: theme.spacing[2],
          borderRadius: theme.spacing[2],
          gap: theme.spacing[1],
          backgroundColor: theme.tokens.colors.surface,
          border: `2px solid ${theme.colors.neutral.neutral_alpha[5]}`,
        }}
      >
        <IconeBusca
          size={theme.typography.font.size[3]}
          color={theme.colors.neutral.neutral_alpha['9']}
        />
        <input
          className={styles.campoBusca}
          placeholder="Buscar por produto ou assinatura"
          style={{
            paddingRight: theme.spacing[1],
            paddingLeft: theme.spacing[1],
          }}
        />
      </div>
    </Header>
  );
}
